import { Platform } from 'react-native';
import type { LinkingOptions, PathConfigMap } from '@react-navigation/native';
import { SCREENS } from './registry';
import { MORE_TAB, TAB_NAMES } from './tabs';

const tabScreens: PathConfigMap<Record<string, object | undefined>> = { [MORE_TAB]: 'more' };
const stackScreens: PathConfigMap<Record<string, object | undefined>> = {};
for (const s of SCREENS) {
  if (TAB_NAMES.has(s.name)) tabScreens[s.name] = s.path;
  else stackScreens[s.name] = s.path;
}

/**
 * Deep links. Web: real URL paths (/leave/apply, /onboarding/<token>, /hr/employees/42).
 * Native: hrms://leave/apply etc.
 */
export const linking: LinkingOptions<Record<string, object | undefined>> = {
  prefixes: ['hrms://', ...(Platform.OS === 'web' && typeof window !== 'undefined' ? [window.location.origin] : [])],
  config: {
    screens: {
      Login: 'login',
      Onboarding: 'onboarding/:token',
      Tabs: { screens: tabScreens } as PathConfigMap<Record<string, object | undefined>>[string],
      ...stackScreens,
      NotFound: '*',
    },
  },
};

/** Paths that don't need a session. */
export const isPublicPath = (path: string) => /^\/?(login|onboarding\/)/.test(path);
